<template>
  <div class="container__method-components-sidebar">
    <b-button v-b-toggle.sidebar-backdrop variant="primary" class="button__open-sidebar">
      <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'bars' }" />
      <span> Method Components</span>
    </b-button>

    <b-sidebar
      id="sidebar-backdrop"
      class="sidebar__method-components"
      backdrop
      width="380"
      :class="mode === 'create' ? 'sidebar__as-owner' : 'sidebar__as-learner'"
    >
      <template #header>
        <b-button v-b-toggle.sidebar-backdrop variant="primary">
          <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'bars' }" class="mr-2" />
          <span>Method Components</span>
        </b-button>
      </template>
      <template #default>
        <slot></slot>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronLeft);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },

  props: {
    mode: {
      type: String,
      required: true,
      validator: (value) => ['create', 'view'].includes(value)
    }
  }
};
</script>

<style lang="scss">
.container__method-components-sidebar {
  --sidebar-bg-color-default: #ffffff;
  --sidebar-bg-color-learner: #eceef7;
  --sidebar-bg-backdrop: #00000052;
  --primary-dark: #3b3e66;

  .b-sidebar-backdrop {
    background-color: var(--sidebar-bg-backdrop) !important;
  }

  .b-sidebar {
    width: 352px;
  }

  .b-sidebar-header {
    padding: 20px;
  }

  .b-sidebar-header,
  .b-sidebar-body {
    color: var(--primary-dark);
    background-color: var(--sidebar-bg-color-default);
  }

  .sidebar__as-owner {
    .b-sidebar-header {
      padding: 20px 20px 0 20px;
    }
    .b-sidebar-body {
      padding: 20px;
    }
  }
  .sidebar__as-learner {
    .b-sidebar-header,
    .b-sidebar-body {
      background-color: var(--sidebar-bg-color-learner);
    }
    .b-sidebar-header {
      padding: 20px 20px 0 20px;
    }
  }

  .button__open-sidebar {
    width: max-content;
  }

  @media screen and (min-width: 576px) {
    .sidebar__as-owner {
      .b-sidebar {
        width: 380px;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .sidebar__as-owner .b-sidebar,
  .sidebar__as-learner .b-sidebar {
    width: 309px;
  }
}
</style>
